import React from "react";
import { LOGO_FULL } from "../lib/vehicleImages";

export const Loading = ({ label = "Analyzing the European market…" }) => (
  <div className="min-h-[60vh] flex flex-col items-center justify-center bg-atlas-navy" data-testid="atlas-loading">
    <img src={LOGO_FULL} alt="ATLAS" className="h-16 w-auto opacity-95" />
    <div className="mt-8 h-8 w-8 rounded-full border-2 border-white/20 border-t-atlas-sky atlas-spin" />
    <p className="mt-5 text-sm text-slate-300 font-mono tracking-wide">{label}</p>
  </div>
);
